import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import { WindowState } from '../../window.reducer';
import { Store } from '@ngrx/store';
import {
  CloseWindow,
  ReopenWindow
} from '../../window.actions';

@Component({
  selector: 'dx-window-task',
  templateUrl: './window-task.component.html',
  styleUrls: ['./window-task.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowTaskComponent implements OnInit {

  @Input() public window: WindowState & { id: string };

  constructor(public store$: Store<any>) { }

  ngOnInit() {
  }

  close() {
    this.store$.dispatch(new CloseWindow(this.window.id))
  }

  reopen() {
    this.store$.dispatch(new ReopenWindow(this.window.id))
  }
}
